// @ts-nocheck
/* eslint-disable */
export const arrowBackLineIcon = {
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.21891 8.00047L10.5188 11.3003L9.57598 12.2431L5.33331 8.00047L9.57598 3.75781L10.5188 4.70062L7.21891 8.00047Z" fill="currentColor"/></svg>`,
  name: 'arrow-back-line' as const,
};
